import { render, staticRenderFns } from "./th-Createtime.vue?vue&type=template&id=3ad58279"
import script from "./th-Createtime.vue?vue&type=script&lang=js"
export * from "./th-Createtime.vue?vue&type=script&lang=js"
import style0 from "./th-Createtime.vue?vue&type=style&index=0&id=3ad58279&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports